/**
 * PRIVACY: Geen user-input naar server, localStorage (behalve onboarding-flag),
 * externe APIs. PortalAuth verify via SDK; minimale Umami analytics (tool_open/close).
 * Opslaan = user-initiated .jari download; printen = window.print().
 */
import { useCallback, useState } from "react";
import {
  ToolLayout,
  PaywallModal,
  Onboarding,
  useAccess,
  hasCompletedOnboarding,
  setOnboardingComplete,
  type OnboardingSlide,
} from "@jari-tools/shared";
import { getAdventures } from "./content";
import { Game } from "./components/Game";

const TOOL_SLUG = import.meta.env.VITE_TOOL_SLUG || "act-avontuur";
const TOOL_NAME = "ACT Avontuur — Defusie";
const PORTAL_URL = import.meta.env.VITE_PORTAL_URL;

const ONBOARDING_SLIDES: OnboardingSlide[] = [
  {
    title: "Welkom bij ACT Avontuur",
    body: "Ga op avontuur en leer omgaan met je gedachten. Alles blijft in je browser — er wordt niets opgeslagen of verzonden.",
  },
  {
    title: "Gedachten als signalen",
    body: "Tijdens je avontuur krijg je signalen van systemen in je voertuig. Dat zijn je gedachten. Sommige helpen je, andere niet.",
  },
  {
    title: "Defusie",
    body: "Soms worden er zóveel gedachten dat je geen keuze meer kunt maken. Dan leer je gedachten weg te klikken — dat heet defusie in ACT.",
  },
  {
    title: "Avonturen en licentie",
    body: "Ruimtereis is gratis. Met een licentie speel je alle avonturen en kun je je eindoverzicht opslaan of printen.",
  },
];

const ADVENTURES = getAdventures();

export function App() {
  const { access, name, loading, error, isPaid } = useAccess();
  const [showOnboarding, setShowOnboarding] = useState(
    () => !hasCompletedOnboarding(TOOL_SLUG)
  );
  const [paywallOpen, setPaywallOpen] = useState(false);
  const [paywallFeature, setPaywallFeature] = useState("deze functie");

  const completeOnboarding = useCallback(() => {
    setOnboardingComplete(TOOL_SLUG);
    setShowOnboarding(false);
  }, []);

  const onPaywall = useCallback((feature: string) => {
    setPaywallFeature(feature);
    setPaywallOpen(true);
  }, []);

  return (
    <>
      <ToolLayout
        toolName={TOOL_NAME}
        access={access}
        userName={name}
        loading={loading}
        error={error}
        portalUrl={PORTAL_URL}
        onShowOnboarding={() => setShowOnboarding(true)}
      >
        <Game
          adventures={ADVENTURES}
          isPaid={isPaid}
          portalUrl={PORTAL_URL}
          onPaywall={onPaywall}
        />
      </ToolLayout>

      <Onboarding
        open={showOnboarding}
        slides={ONBOARDING_SLIDES}
        onComplete={completeOnboarding}
        onSkip={completeOnboarding}
      />

      <PaywallModal
        open={paywallOpen}
        onClose={() => setPaywallOpen(false)}
        featureTitle={paywallFeature}
        portalUrl={PORTAL_URL}
      />
    </>
  );
}
